import { useAppDispatch, useAppSelector } from 'app/store/store';
import { setAppLoading, toggleAppStarting } from 'app/store/reducers/app/appState';
import { useEffect } from 'react';
import { userProfilesApi } from 'app/store/reducers/api/config-manager-cloud-services/store/user-profiles';
import { accountProfileApi } from 'app/store/reducers/api/config-manager-cloud-services/store/account-profiles';

export const useAppStarting = () => {
  const { appLoading, appStarting } = useAppSelector(state => state.appState);
  const dispatch = useAppDispatch();

  const { data: userProfile, isFetching: userProfileLoading } =
    userProfilesApi.endpoints.getCurrentUserProfile.useQueryState();

  const { data: accountProfile = {}, isFetching: accountProfileLoading } =
    accountProfileApi.endpoints.getCurrentAccountProfile.useQueryState();

  useEffect(() => {
    dispatch(setAppLoading(userProfileLoading || accountProfileLoading));
  }, [userProfileLoading || accountProfileLoading]);

  // useEffect is useless here ?
  useEffect(() => {
    if (appStarting && !appLoading) {
      dispatch(toggleAppStarting());
    }
  }, [appLoading]);
};
